import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 14l6 -6l4 4l9 -9","key":"svg-0"}],["path",{"d":"M15 3h6v6","key":"svg-1"}],["path",{"d":"M15 21h6v-6","key":"svg-2"}],["path",{"d":"M21 21l-6 -6","key":"svg-3"}]]

const IconTrendingUpDown = createReactComponent('outline', 'trending-up-down', 'TrendingUpDown', __iconNode);

export default IconTrendingUpDown;